import React from "react";

const IconSnapchat = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={25}
      viewBox="0 0 448 512"
      fill="currentColor"
      {...props}
    >
      <path d="M224 32C107 32 32 133 32 240c0 91 57 167 135 198-1 17-2 39-8 52-8 18-33 18-45 0-10-15-28-23-46-23-11 0-22 4-30 11-12 10-28 16-44 16-13 0-24-11-24-24 0-20 20-28 37-35 23-9 38-29 38-52 0-8-2-16-4-24-2-8-4-16-4-24 0-13 11-24 24-24h14c16 0 28 12 28 28 0 15 6 29 16 39 9 9 21 15 34 15s25-6 34-15c10-10 16-24 16-39 0-16 12-28 28-28h14c13 0 24 11 24 24 0 8-2 16-4 24-2 8-4 16-4 24 0 23 15 43 38 52 17 7 37 15 37 35 0 13-11 24-24 24-16 0-32-6-44-16-8-7-19-11-30-11-18 0-36 8-46 23-12 18-37 18-45 0-6-13-7-35-8-52 78-31 135-107 135-198 0-107-75-208-192-208z" />
    </svg>
  );
};

export default IconSnapchat;
